import { getConfig } from '../config';

import base64Generate from './base64/generate';

// TODO: currently this function works only for internal requests
export const fetchJson = (url, options = {}, retries = 0, backoff = 300) => {
  const retryCodes = [408, 500, 502, 503, 504, 522, 524];
  const config = getConfig();

  const fetchOptions = {
    ...options,
    headers: {
      ...options.headers,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Correlation-ID': `WWW-LATAM-${config.locale}.${base64Generate()}`,
    },
  };

  if (options.body) {
    fetchOptions.body = JSON.stringify(options.body);
  }

  return fetch(url, fetchOptions, retries, backoff)
    .then(response => {
      if (response.status >= 200 && response.status < 300) {
        return response.json();
      }

      if (retries > 0 && retryCodes.includes(response.status)) {
        return new Promise(resolve => {
          setTimeout(
            () => resolve(fetchJson(url, fetchOptions, retries - 1, backoff * 2)), backoff,
          );
        });
      }

      const error = new Error(`Response HTTP status code is ${response.status}`);
      error.response = response;
      throw error;
    });
};

export default {
  fetchJson,
};
